import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { LeadV2Status } from "../../api/generated";

export const useLeadStatusOptions = () => {
  const { t } = useTranslation();
  return useMemo(
    () => [
      {
        value: LeadV2Status.IncompleteProfile,
        label: t("leadsPage_table_status_incomplete_profile"),
      },
      {
        value: LeadV2Status.CompletingProfile,
        label: t("leadsPage_table_status_completing_profile"),
      },
      {
        value: LeadV2Status.ReviewingSuitability,
        label: t("leadsPage_table_status_review_suitability"),
      },
      {
        value: LeadV2Status.IdentifyVerification,
        label: t("leadsPage_table_status_identify_verification"),
      },
      {
        value: LeadV2Status.VerifyingIdentity,
        label: t("leadsPage_table_status_verifying_identity"),
      },
      {
        value: LeadV2Status.Unknown,
        label: t("leadsPage_table_status_unknown"),
      },
    ],
    [t],
  );
};
